"use strict";

var _core = require("@emotion/core");

var __makeTemplateObject = void 0 && (void 0).__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bumper = void 0;

var React = __importStar(require("react")); // @ts-ignore


var utils_1 = require("@bdl-cmn-shared-packages-npm/utils");

var foundation_1 = require("../../theme/foundation");

var utils_2 = require("../../utils");

var lseds_1 = require("../../lseds");

var core_1 = require("@emotion/core");

var faTimes_1 = require("@fortawesome/free-solid-svg-icons/faTimes");

var react_fontawesome_1 = require("@fortawesome/react-fontawesome");

var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons/");

var buttons_1 = require("../buttons");

var faInfoCircle_1 = require("@fortawesome/free-solid-svg-icons/faInfoCircle");

var faExclamationTriangle_1 = require("@fortawesome/free-solid-svg-icons/faExclamationTriangle");

exports.Bumper = utils_2.forwardRef(function Grid(props, ref) {
  var duration = props.duration,
      type = props.type,
      closable = props.closable,
      message = props.message,
      sticky = props.sticky;

  var _a = React.useState(false),
      visibleBumper = _a[0],
      setVisibleBumper = _a[1];

  var _b = React.useState(false),
      removeBumper = _b[0],
      setRemoveBumper = _b[1];

  React.useEffect(function () {
    setTimeout(function () {
      setVisibleBumper(true);

      if (!sticky) {
        setTimeout(function () {
          setVisibleBumper(false);
          setTimeout(function () {
            setRemoveBumper(true);
          }, 200);
        }, duration || 3000);
      }
    }, 100);
  }, []);

  var backgroundType = function backgroundType(typeEvent) {
    switch (typeEvent) {
      case 'success':
        return foundation_1.colors.status.success;

      case 'info':
        return foundation_1.colors.white;

      case 'warning':
        return foundation_1.colors.status.warning;

      case 'error':
        return foundation_1.colors.status.error;

      default:
        return foundation_1.colors.status.success;
    }
  };

  var getIcon = function getIcon(typeEvent) {
    switch (typeEvent) {
      case 'success':
        return free_solid_svg_icons_1.faCheck;

      case 'info':
        return faInfoCircle_1.faInfoCircle;

      case 'warning':
        return faExclamationTriangle_1.faExclamationTriangle;

      case 'error':
        return faTimes_1.faTimes;

      default:
        return faInfoCircle_1.faInfoCircle;
    }
  };

  var bumperContainer = core_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tposition: fixed;\n\t\t\ttop: ", ";\n\t\t\tcolor: ", ";\n\t\t\theight: 3.5em;\n\t\t\talign-items: center;\n\t\t\tpadding-left: 1rem;\n\t\t\tpadding-right: 1rem;\n\t\t\tjustify-content: space-between;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tz-index: 100;\n\t\t\tbackground: ", ";\n\t\t\tdisplay: ", ";\n\t\t\tbox-shadow: 0 0.313em 0.625em rgba(66, 85, 99, 0.25);\n\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tposition: fixed;\n\t\t\ttop: ", ";\n\t\t\tcolor: ", ";\n\t\t\theight: 3.5em;\n\t\t\talign-items: center;\n\t\t\tpadding-left: 1rem;\n\t\t\tpadding-right: 1rem;\n\t\t\tjustify-content: space-between;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tz-index: 100;\n\t\t\tbackground: ", ";\n\t\t\tdisplay: ", ";\n\t\t\tbox-shadow: 0 0.313em 0.625em rgba(66, 85, 99, 0.25);\n\n\t\t\ttransition: all 0.2s ease-in-out;\n\t\t}\n\t"])), visibleBumper ? '0' : '-80px', type && type === 'info' ? foundation_1.colors.secondary.darkGrey : foundation_1.colors.white, backgroundType(type), removeBumper ? 'none' : 'flex');
  var bumper = core_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 800;\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 100%;\n\t\t\tfont-size: 16px;\n\t\t\tfont-weight: 800;\n\t\t}\n\t"])));
  var icon = core_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t\t {\n\t\t\tmargin-right: 1em;\n\t\t\tfont-size: 1.125em;\n\t\t\t", ";\n\t\t}\n\t"], ["\n\t\t {\n\t\t\tmargin-right: 1em;\n\t\t\tfont-size: 1.125em;\n\t\t\t", ";\n\t\t}\n\t"])), type && type === 'info' && "color: " + foundation_1.colors.status.info + ";");
  var action = core_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t\t {\n\t\t\twidth: 50px;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tsvg {\n\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"], ["\n\t\t {\n\t\t\twidth: 50px;\n\t\t\theight: 100%;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tsvg {\n\t\t\t\t\ttransform: scale(1.1);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t"])));
  return (0, _core.jsx)(lseds_1.lseds.div, {
    ref: ref,
    css: bumperContainer
  }, type && (0, _core.jsx)(lseds_1.lseds.div, {
    css: icon
  }, (0, _core.jsx)(react_fontawesome_1.FontAwesomeIcon, {
    icon: getIcon(type)
  })), (0, _core.jsx)(lseds_1.lseds.div, {
    css: bumper
  }, message), (closable || sticky) && (0, _core.jsx)(lseds_1.lseds.div, {
    css: action
  }, (0, _core.jsx)(buttons_1.FloatingButton, {
    icon: 'times',
    size: 'small',
    onClick: function onClick() {
      setVisibleBumper(false);
      setTimeout(function () {
        setRemoveBumper(true);
      }, 200);
    }
  })));
});

if (utils_1.isDev) {
  exports.Bumper.displayName = 'Bumper';
}

var templateObject_1, templateObject_2, templateObject_3, templateObject_4;